// External deps
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { Table } from 'ypf-pas-general-ui-components';
import { BsCheckLg } from 'react-icons/bs';

// Se uso de base TotalLineTable, hay que modificarlo completo

const getColumns = (currency) => [
  {
    Header: 'Sinc',
    accessor: 'sincronizado',
    hideSort: true,
    // eslint-disable-next-line react/prop-types
    Cell: ({ value }) =>
      value ? <BsCheckLg style={{ fill: '#219E66', width: '20px', height: '20px' }} /> : <></>
  },
  {
    Header: 'Posición',
    accessor: 'posicion',
    hideSort: true,
    style: {
      fontWeight: '600'
    }
  },
  {
    Header: 'Línea',
    accessor: 'linea',
    hideSort: true,
    style: {
      fontWeight: '600'
    }
  },
  {
    Header: 'Cant. Reg.',
    accessor: 'cantReg',
    style: {
      fontWeight: '600'
    }
  },
  {
    Header: 'Cant. Cert.',
    accessor: 'cantCert',
    style: {
      fontWeight: '600'
    }
  },
  {
    Header: `PxQ (${currency})`,
    accessor: 'pxQ',
    hideSort: true,
    style: {
      fontWeight: '600',
      textAlign: 'right'
    },
    Cell: ({ row }) => `${row.values.pxQ}`
  }
];

// Receives the cantReg or cantCert and return its number value, because comes as string "99 DIA" for example
// Examples: extractNumberOfCant("22,000 T/K") => Returns 22 as number. Other: extractNumberOfCant("22.412,050 T/K") => returns 22412.05 as number
const extractNumberOfCant = (cant) => Number(cant.split(' ')[0].replace('.', '').replace(',', '.'));

export const sortByDate = (firstWR, secondWR, descendantSort) => {
  if (descendantSort) {
    return dayjs(firstWR.fecha).isBefore(secondWR.fecha) ? 1 : -1;
  }

  return dayjs(firstWR.fecha).isAfter(secondWR.fecha) ? 1 : -1;
};

export const sortByCant = (firstWR, secondWR, descendantSort, column) => {
  if (descendantSort) {
    return extractNumberOfCant(secondWR[column]) - extractNumberOfCant(firstWR[column]);
  }

  return extractNumberOfCant(firstWR[column]) - extractNumberOfCant(secondWR[column]);
};
const TotalLineOverviewTable = ({ dailyWorkReports, serviceRequestCurrency }) => {
  const [data, setData] = useState(dailyWorkReports);

  const sortData = ({ sortBy }) => {
    const columnToSort = sortBy[0]?.id;
    const descendantSort = sortBy[0]?.desc;
    const newData = [...data];

    newData.sort((firstWR, secondWR) => {
      switch (columnToSort) {
        case 'fecha':
          return sortByDate(firstWR, secondWR, descendantSort);
        case 'cantReg':
        case 'cantCert':
          return sortByCant(firstWR, secondWR, descendantSort, columnToSort);
        default:
          return 0;
      }
    });

    setData(newData);
  };

  useEffect(() => {
    setData(dailyWorkReports);
  }, [dailyWorkReports]);

  return (
    <Table
      columns={getColumns(serviceRequestCurrency)}
      data={data || []}
      fetchData={sortData}
      initialState={{
        sortBy: [
          {
            id: '',
            desc: null
          }
        ]
      }}
      sortOrder
      titleLeft
    />
  );
};

export default TotalLineOverviewTable;

TotalLineOverviewTable.propTypes = {
  dailyWorkReports: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      fecha: PropTypes.string,
      cantidad: PropTypes.string,
      um: PropTypes.string,
      estado: PropTypes.string,
      color: PropTypes.string
    })
  ),
  serviceRequestCurrency: PropTypes.string
};

TotalLineOverviewTable.defaultProps = {
  dailyWorkReports: [],
  serviceRequestCurrency: ''
};
